import { jwpPlayerId } from "../constants";
import domWrap from "../utils/domWrap";
import h from "../utils/htm";
import http from "../utils/http";
import playerTrack from '../utils/playerTrack';

export default async body => { // 'body'
	let globalPlaylist = [],
		activePlayer = {};
	
	[...document.querySelectorAll('a.resource-item[type="VID"]')].forEach(vid => {
		const 	index = globalPlaylist.length,
				jwpid = (vid.getAttribute('jwpid') || vid.getAttribute('href') || '').substr(1);

		if(!jwpid) return;

		globalPlaylist[index] = undefined;
		vid.setAttribute('vindex', index.toString());
		http('https://content.jwplatform.com/feeds/' + jwpid + '.json').get()
			.then(data => globalPlaylist[index] = data.playlist[0])
			.catch(console.log);
	});


	domWrap(body).on('click', 'a.resource-item',async function (e) {
		const 	type = this.getAttribute('type');
		if (['VID', 'IMG'].indexOf(type) === -1) return true;
		e.preventDefault();

		(async () => {
			const 	{default: jwp} = await import('../libs/jwplayerMod'),
					{default: lightbox} = await import('../utils/lightbox'),
					assetId = this.getAttribute('assetid'),
					loc = location.href,
					href = this.getAttribute('href') || '';
			
			if (type === 'IMG') {
				lightbox('<img src="' + href + '">');
			}
			else if (type === 'VID') {
				lightbox(h('div class="vid-holder"', h('div')(href ? 'span actions' : '',h('a href="'+href+'" target="_blank" class="download" download','Download')('a href="mailto:?subject=Freightliner Video&body=Video URL: '+ encodeURIComponent('https://'+href.split('//').pop())+'" class="email" target="mailto-target" email','Email'))('iframe name="mailto-target"')), () => {

					const lb = document.querySelector('#modal-lightbox .vid-holder > div');

					// determine which video player to load
					const attrJWPlayerId = this.getAttribute('jwpid');

					if (attrJWPlayerId && attrJWPlayerId.length > 1) {
						activePlayer = jwp(lb);

						if (this.classList.contains("btn-jwlauncher")) {
							loadVideos({ self: this, playlist: null, activePlayer });
						} else {
							loadVideos({ self: this, playlist: globalPlaylist, activePlayer });
						}
					}
					else {
						const src = this.getAttribute('href');
						if (src) {
							activePlayer = document.createElement('video');
							activePlayer.setAttribute('autoplay', 'autoplay');
							activePlayer.setAttribute('src', src);
							activePlayer.setAttribute('controls', 'controls');
							activePlayer.setAttribute('style', 'width:100%');
							lb.appendChild(activePlayer);
							setTimeout(() => {
								activePlayer.play();
							}, 0);
						}
					}

					// Add History
					if (assetId) {
						history.replaceState({}, "Video", "/video/" + assetId);
					}

				}, function () {
					try {
						if (activePlayer.remove)
							activePlayer.remove();
						if (activePlayer.pause)
							activePlayer.pause();
					} catch (e) { }
					
					// Pop History
					if(assetId){
						history.replaceState({}, document.title, loc);
					}
				});
			}
		})();
		
	});
};

function loadVideos({ self, playlist, activePlayer }) {
	var jwpid = self.getAttribute('jwpid').substr(1);
	if (!playlist || !playlist.find( (obj) => obj && obj.mediaid === jwpid )){
		http('https://content.jwplatform.com/feeds/' + jwpid + '.json').get()
			.then(data => {
				setupActivePlayer({playlist: data.playlist,activePlayer});
				playVideo({index:0,activePlayer});
			})
			.catch(console.log);
	} else {
		setupActivePlayer({playlist,activePlayer});
		//activePlayer.setCurrentQuality(0);
		playVideo({index:parseInt(self.getAttribute('vindex')), activePlayer});
	}
}

function setupActivePlayer({playlist,activePlayer}) {
	activePlayer.setup({
		width: 560,
		height: 315,
		autostart: false,
		pid: jwpPlayerId,
		playlist
	});
}

function playVideo({index,activePlayer}) {
	// For some reason autoplaying fails in some cases and in some browsers if there is not a timeout.
	setTimeout(() => {
		activePlayer.playlistItem(index);
		activePlayer.pause();
		setTimeout(() => activePlayer.play(), 0);
	}, 0);
	playerTrack(activePlayer);
}